import l10n from "@/services/l10n";

export default ({ track, player, active = true }) => {
  return {
    active,
    title: l10n("REMOVE_FROM_QUEUE"),
    icon: "queue",
    action() {
      player.removeFromQueue(track);
    }
  };
};
